import { Box } from '@mui/material'
import { GridColDef, GridRenderCellParams, GridTreeNodeWithRender } from '@mui/x-data-grid-premium'
import { AvailableLocale } from '@omnea-digital/toolbox'
import isEmpty from 'lodash/isEmpty'
import { Flag } from '@omnea-app/fe-form-viewer/Flag'
import { MuiTelInputCountry } from '@omnea-app/fe-form-viewer/PhoneNumberHelpers'
import { CountryCode } from '@omnea-app/packages/universal/countries/countryCodes'
import { isDefined } from '@omnea-app/packages/universal/type-guards/isDefined'
import { RowGroupingColumnTableCell } from '../../row-grouping/components/RowGroupingColumnTableCell'
import { ROW_GROUPING_NONE_GROUPING_TEXT_VALUE } from '../../row-grouping/helpers'
import { BaseColumnConfig } from '../types'
import { baseColumnConfig } from './baseColumnConfig'
import type { GridValidRowModel } from '@mui/x-data-grid/models/gridRows'

export type CountryColumnConfig<T extends GridValidRowModel> = BaseColumnConfig<T, 'country'> & {
  columnType: 'country'
  locale: AvailableLocale
  getIsoCode: (params: GridRenderCellParams<T, any, any, GridTreeNodeWithRender>) => MuiTelInputCountry | CountryCode | null
  groupingValueGetter?: GridColDef<T>['groupingValueGetter']
  editable?: boolean
}

export const getCountryColumn = <T extends GridValidRowModel>({
  style,
  locale,
  ...config
}: CountryColumnConfig<T>): GridColDef<T> => ({
  ...baseColumnConfig,
  ...style,
  ...config,
  groupingValueGetter: config.groupingValueGetter ?? config.valueGetter,
  renderCell: (params) => {
    if (!isDefined(params.value)) return null
    if (params.rowNode.type === 'group') {
      return (
        <RowGroupingColumnTableCell
          columnHeaderName={config.headerName}
          value={!isEmpty(params.value) ? params.value : ROW_GROUPING_NONE_GROUPING_TEXT_VALUE}
          id={params.id}
        />
      )
    }
    const isoCode = config.getIsoCode(params)
    return (
      <Box display="flex" gap={0}>
        {isoCode && <Flag isoCode={isoCode} size={20} sx={{ mr: 2, flexShrink: 0 }} />}
        {params.value}
      </Box>
    )
  },
})
